import React from 'react'
import { User } from '../../models/User'
import { EmailTable } from './Table/EmailTable'
import { ContactEmailsInitialization } from './Initialization/EmailHubInitialization'
import { useNavigate, useParams } from 'react-router-dom'
import { EmailThreadView } from './ThreadView/EmailThreadView'
import { Button } from '../../components/Button/Button'
import { IntegrationEmailThread } from '../../models/Email'
import { useAppSelector } from '../../store/hooks'
import { selectCurrentUserEmailIntegration } from '../../store/emailHub/emailUsers'

export interface ContactEmailsProps {
  contact: User
}

export const ContactEmailsV2: React.FC<ContactEmailsProps> = ({ contact }) => {
  return (
    <>
      <ContactEmailsInitialization contact={contact} />
      <>
        <ContactEmailsContent contact={contact} />
      </>
    </>
  )
}

export interface ContactEmailsContentProps {
  contact: User
}

const ContactEmailsContent: React.FC<ContactEmailsContentProps> = ({ contact }) => {
  const { threadId } = useParams()
  const navigate = useNavigate()

  const emailIntegration = useAppSelector(selectCurrentUserEmailIntegration)

  const navigateToInbox = () => {
    navigate(`/library/manage-contacts/contacts/${contact.id}/tabs/emails`)
  }

  const handleRowClicked = (thread: IntegrationEmailThread) =>
    navigate(`/library/manage-contacts/contacts/${contact.id}/tabs/emails/threads/${thread.externalId}`)

  if (!emailIntegration) {
    return null
  }

  if (threadId) {
    return (
      <div className='d-flex flex-column mb-3'>
        <div className='d-flex ps-3 align-items-start'>
          <Button variant='link' className='button-small' onClick={navigateToInbox}>
            Back
          </Button>
        </div>
        <EmailThreadView emailConnector={emailIntegration.serviceId} threadId={threadId} />
      </div>
    )
  }

  return <EmailTable onRowClicked={handleRowClicked} />
}
